import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import Input from 'components/Input';
import styles from './EmailFilter.module.scss';

function EmailFilter() {
  const dispatch = useDispatch();
  const { learnerEmail } = useSelector(currentFiltersSelector);

  const handleOnChange = useCallback(
    (event) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.learnerEmail,
          value: event.target.value,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Learner Email ID"
      labelClassName="h5"
    >
      <Input
        className={styles.input}
        placeholder="Add Email ID"
        value={learnerEmail}
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default EmailFilter;
